/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VerifyUnipassPersonResVo } from './VerifyUnipassPersonResVo';
import {
    VerifyUnipassPersonResVoFromJSON,
    VerifyUnipassPersonResVoFromJSONTyped,
    VerifyUnipassPersonResVoToJSON,
    VerifyUnipassPersonResVoToJSONTyped,
} from './VerifyUnipassPersonResVo';

/**
 * 
 * @export
 * @interface ResponseListVerifyUnipassPersonResVo
 */
export interface ResponseListVerifyUnipassPersonResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListVerifyUnipassPersonResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListVerifyUnipassPersonResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<VerifyUnipassPersonResVo>}
     * @memberof ResponseListVerifyUnipassPersonResVo
     */
    data?: Array<VerifyUnipassPersonResVo>;
}

/**
 * Check if a given object implements the ResponseListVerifyUnipassPersonResVo interface.
 */
export function instanceOfResponseListVerifyUnipassPersonResVo(value: object): value is ResponseListVerifyUnipassPersonResVo {
    return true;
}

export function ResponseListVerifyUnipassPersonResVoFromJSON(json: any): ResponseListVerifyUnipassPersonResVo {
    return ResponseListVerifyUnipassPersonResVoFromJSONTyped(json, false);
}

export function ResponseListVerifyUnipassPersonResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListVerifyUnipassPersonResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(VerifyUnipassPersonResVoFromJSON)),
    };
}

export function ResponseListVerifyUnipassPersonResVoToJSON(json: any): ResponseListVerifyUnipassPersonResVo {
    return ResponseListVerifyUnipassPersonResVoToJSONTyped(json, false);
}

export function ResponseListVerifyUnipassPersonResVoToJSONTyped(value?: ResponseListVerifyUnipassPersonResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(VerifyUnipassPersonResVoToJSON)),
    };
}

